import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_ORIGIN](state, payload) {
    state.origin = payload;
  },
  [MutationsType.SET_ORIGINS](state, payload) {
    state.origins = payload;
  },
  [MutationsType.ADD_ORIGIN](state, payload) {
    if (state.origins) state.origins.unshift(payload);
  },
  [MutationsType.UPDATE_ORIGIN](state, payload) {
    let ind = state.origins?.findIndex((origin) => origin.id === payload.id);
    if (ind >= 0) Vue.set(state.origins, ind, { ...state.origins[ind], ...payload });
    if (state.origin && payload.id === state.origin.id) {
      state.origin = { ...state.origin, ...payload };
    }
  },
  [MutationsType.DELETE_ORIGIN](state, payload) {
    let ind = state.origins?.findIndex((origin) => origin.id === payload);
    if (ind >= 0) state.origins.splice(ind, 1);
  },
  [MutationsType.SET_ORIGIN_SELECTED](state, payload) {
    state.originSelected = payload;
  },
  [MutationsType.RESET_ORIGINS](state) {
    state.origins = null;
  },
};
